module.exports = __webpack_public_path__ + "assets/img/4w.bcaef94b.png";